export const isAutoplayEnabled: () => boolean = () => {
  return localStorage.getItem("autoplay") !== "false";
};

export const setIsAutoplayEnabled = (autoplay: boolean) => {
  localStorage.setItem("autoplay", JSON.stringify(autoplay));
};

export const isClientScheduledEnabled: () => boolean = () => {
  return localStorage.getItem("clientScheduledEnabled") !== "false";
};
export const setClientScheduledEnabled = (clientScheduledEnabled: boolean) => {
  localStorage.setItem(
    "clientScheduledEnabled",
    JSON.stringify(clientScheduledEnabled),
  );
};

export const isSubtitlesEnabled: () => boolean = () => {
  return localStorage.getItem("subtitlesEnabled") === "true";
};

export const setIsSubtitlesEnabled = (subtitlesEnabled: boolean) => {
  localStorage.setItem("subtitlesEnabled", JSON.stringify(subtitlesEnabled));
};
export const getPreferredSubtitleLanguage: () => string | null = () => {
  return localStorage.getItem("preferredSubtitleLanguage");
};

export const setPreferredSubtitleLanguage = (languageCode: string) => {
  localStorage.setItem("preferredSubtitleLanguage", languageCode);
};

/**
 * The following methods allow us to cache useQuery statements in local storage to improve performance
 * By default we are setting the caches to expire 24hours from first load else they will be ignored
 */
export const setUseQueryLocalStorage = (key: string, data: unknown) => {
  const expiryTime = Date.now() + 24 * 60 * 60 * 1000; // Set expiry time to 24 hours from now
  localStorage.setItem(
    key,
    JSON.stringify({ data, expiryTime }), // Store data with expiry
  );
};
export const getUseQueryLocalStorage = (key: string) => {
  try {
    const cachedItem = localStorage.getItem(key);
    if (cachedItem) {
      const { data, expiryTime } = JSON.parse(cachedItem);
      if (Date.now() < expiryTime) {
        return data; // Data is still valid
      } else {
        localStorage.removeItem(key); // Cache expired, remove it
      }
    }
  } catch (e) {
    localStorage.removeItem(key); // Cache leads to exception, dont use it
  }
  return undefined;
};
